import SimpleHeader from "../../NewApp/SimpleHeader";
import "./IndexInvesting.css";
import book from "../../../assets/index_investing.png";
import BookBlock from "../../reusable/BookBlock/BookBlock";
import Footer from "../../Footer/Footer";

const IndexInvesting: React.FC = () => (
  <div className="book-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />
    <div className="book-page-title">Ներդրումներ ինդեքսներում</div>
    <div className="book-page-description">Ամենապարզ ուղեցույցը, որը կօգնի սկսել ներդրումները ֆոնդային շուկայի ինդեքսներում</div>
    <div className="book-page-content">
        <BookBlock
        imageSrc={book}
        imageAlt={'index investing'}
        paragraphs={[
            'Բացահայտեք ինդեքսային ներդրումների ուժը՝ կապիտալ ստեղծելու և ֆինանսական ազատություն ձեռք բերելու պարզ ու ապացուցված ուղին։', 
            'Այս գիրքը քայլ առ քայլ ուղեցույց է բոլոր նրանց համար, ովքեր ցանկանում են վերահսկել իրենց ֆինանսական ապագան՝ առանց բաժնետոմսերի ընտրության կամ շուկայական քաոսում խճճվելու։ Այն հիմնված է ներդրումների հավերժական սկզբունքների վրա և կբացատրի․', 
            '- Ինչ են ինդեքսային ֆոնդերը', 
            '- Ինչպես կառուցել դիվերսիֆիկացված և ցածր ծախսերով պորտֆել', 
            '- ETF-ների դերը և ինչպես ճիշտ կիրառել դրանք', 
            '- Երկարաժամկետ ներդրումների հաջողության և թոշակային պլանավորման ռազմավարությունները', 
            '- Գործնական պարզ կանոններ (օր.՝ 4%-ի կանոնը)', 
            'Անկախ նրանից՝ նոր եք սկսում ներդրումներով զբաղվել թե ոչ, այս գիրքը կտա հստակություն և վստահություն՝ կառուցելու կայուն ֆինանսական ապագա՝ առանց անհանգստությունների։', 
            `Այս ուղեցույցը ստեղծվել է <a href="http://themarkethustle.com" target="The Market Hustle" rel="noopener noreferrer">The Market Hustle</a>-ի ուղեցույցի հիման վրա`, 
            `<a href="http://girlsandfinances.com/index_investing_armenian.pdf" target="_blank" rel="noopener noreferrer">Ներբեռնել PDF տարբերակը</a>`]}
      />
    </div>
    <Footer></Footer>
  </div>
);

export default IndexInvesting;